import { ComplianceCustomersData } from '@/redux/models';

export const usersDemoData: ComplianceCustomersData = {
  entries: [
    {
      key: '1',
      user: 'User_5',
      risk: 'high',
      totalTransfers: 5,
      totalFunds: 12382.18,
      riskyFunds: 3485.92,
      totalAlerts: 6,
      newAlerts: 3,
      country: 'UA',
      isSuspended: false,
      lastActivity: '2025-03-10T12:00:00Z',
    },
    {
      key: '2',
      user: 'User_4',
      risk: 'medium',
      totalTransfers: 1,
      totalFunds: 9959.4,
      riskyFunds: 1195.13,
      totalAlerts: 2,
      newAlerts: 1,
      isSuspended: true,
      lastActivity: '2025-03-09T08:30:00Z',
    },
    {
      key: '3',
      user: 'User_3',
      risk: 'severe',
      totalTransfers: 3,
      totalFunds: 297732.2,
      riskyFunds: 59550.33,
      totalAlerts: 10,
      newAlerts: 7,
      lastActivity: '2025-03-10T09:15:00Z',
    },
    {
      key: '4',
      user: 'User_2',
      risk: 'high',
      totalTransfers: 4,
      totalFunds: 11500.0,
      riskyFunds: 2837.5,
      totalAlerts: 5,
      newAlerts: 2,
    },
    {
      key: '5',
      user: 'User_1',
      risk: 'low',
      totalTransfers: 2,
      totalFunds: 7500.0,
      riskyFunds: 397.5,
      totalAlerts: 1,
      newAlerts: 0,
    },
  ],
  total: 5,
};
